const getSideLinks = (postData) => {
  let resp = {
    isApp: false,
    success: true,
    shouldShowOnlineGiving: true,
    shouldShowFNC: true,
  };

  return resp;
};

export default getSideLinks;
